"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALLET_PROVIDERS = exports.WalletType = void 0;
const tslib_1 = require("tslib");
const sol_wallet_adapter_1 = (0, tslib_1.__importDefault)(require("@project-serum/sol-wallet-adapter"));
const adapters_1 = require("./adapters");
const coin98_1 = require("./adapters/coin98");
const secret_key_1 = require("./adapters/secret-key");
const solflare_1 = require("./adapters/solflare");
const solflare_extension_1 = require("./adapters/solflare-extension");
const icons_1 = require("./icons");
var WalletType;
(function (WalletType) {
    WalletType["Coin98"] = "Coin98";
    WalletType["Ledger"] = "Ledger";
    WalletType["MathWallet"] = "MathWallet";
    WalletType["Phantom"] = "Phantom";
    WalletType["Sollet"] = "Sollet";
    WalletType["SolletExtension"] = "SolletExtension";
    WalletType["Solflare"] = "Solflare";
    WalletType["SolflareExtension"] = "SolflareExtension";
    WalletType["Solong"] = "Solong";
    WalletType["SecretKey"] = "SecretKey";
})(WalletType = exports.WalletType || (exports.WalletType = {}));
exports.WALLET_PROVIDERS = {
    [WalletType.Sollet]: {
        name: "Sollet",
        url: "https://www.sollet.io",
        icon: icons_1.SOLLET,
        makeAdapter: sol_wallet_adapter_1.default,
        isMobile: true,
    },
    [WalletType.SolletExtension]: {
        name: "Sollet Extension",
        url: "https://chrome.google.com/webstore/detail/sollet/fhmfendgdocmcbmfikdcogofphimnkno",
        icon: icons_1.SOLLET,
        makeAdapter: adapters_1.SolletExtensionAdapter,
        isInstalled: () => window.sollet !== undefined,
    },
    [WalletType.Ledger]: {
        name: "Ledger",
        url: "https://www.ledger.com",
        icon: icons_1.LEDGER,
        makeAdapter: adapters_1.LedgerWalletAdapter,
    },
    [WalletType.Solong]: {
        name: "Solong",
        url: "https://solongwallet.com/",
        icon: "https://raw.githubusercontent.com/solana-labs/oyster/main/assets/wallets/solong.png",
        makeAdapter: adapters_1.SolongWalletAdapter,
        isInstalled: () => window.solong !== undefined,
    },
    [WalletType.Phantom]: {
        name: "Phantom",
        url: "https://www.phantom.app",
        icon: icons_1.PHANTOM,
        makeAdapter: adapters_1.PhantomWalletAdapter,
        isInstalled: () => { var _a; return ((_a = window.solana) === null || _a === void 0 ? void 0 : _a.isPhantom) === true; },
    },
    [WalletType.MathWallet]: {
        name: "MathWallet",
        url: "https://www.mathwallet.org",
        icon: icons_1.MATHWALLET,
        makeAdapter: adapters_1.MathWalletAdapter,
        isInstalled: () => { var _a; return ((_a = window.solana) === null || _a === void 0 ? void 0 : _a.isMathWallet) === true; },
        isMobile: true,
    },
    [WalletType.Coin98]: {
        name: "Coin98",
        url: "https://docs.coin98.com/products/coin98-wallet",
        icon: icons_1.COIN98,
        makeAdapter: coin98_1.Coin98Adapter,
        isInstalled: () => window.coin98 !== undefined,
        isMobile: true,
    },
    [WalletType.SecretKey]: {
        name: "Secret Key",
        url: "https://solana.com/",
        icon: icons_1.FILE,
        makeAdapter: secret_key_1.SecretKeyAdapter,
    },
    [WalletType.Solflare]: {
        name: "Solflare",
        url: "https://solflare.com/provider",
        icon: icons_1.SOLFLARE,
        makeAdapter: solflare_1.SolflareAdapter,
    },
    [WalletType.SolflareExtension]: {
        name: "Solflare Extension",
        url: "https://solflare.com/",
        icon: icons_1.SOLFLARE,
        makeAdapter: solflare_extension_1.SolflareExtensionWalletAdapter,
        isInstalled: () => { var _a; return ((_a = window.solflare) === null || _a === void 0 ? void 0 : _a.isSolflare) === true; },
    },
};
//# sourceMappingURL=providers.js.map